import type {RepositoryNWO} from '@github-ui/current-repository'

import {CommitGroup} from '../components/Commits/CommitGroup'
import {baseEmptyStateNotLoading, DeferredCommitDataProvider} from '../contexts/DeferredCommitDataContext'
import type {CommitGroup as CommitGroupType, DeferredData} from '../types/commits-types'

export type CommitsProps = {
  buildCommitPath?: (args: {owner: string; repo: string; commitish: string}) => string
  leadingContent?: React.ReactNode
  commitGroups: CommitGroupType[]
  trailingContent?: React.ReactNode
  repository: RepositoryNWO
  deferredCommitData?: DeferredData
  currentBlobPath?: string
  shouldClipTimeline?: boolean
  softNavToCommit?: boolean
}

export function Commits({
  buildCommitPath,
  leadingContent,
  commitGroups,
  trailingContent,
  deferredCommitData = baseEmptyStateNotLoading,
  repository,
  currentBlobPath,
  shouldClipTimeline = true,
  softNavToCommit = false,
}: CommitsProps) {
  return (
    <DeferredCommitDataProvider deferredData={deferredCommitData}>
      {leadingContent}

      {commitGroups.map((commitGroup, index) => {
        return (
          <CommitGroup
            key={commitGroup.title}
            title={commitGroup.title}
            buildCommitPath={buildCommitPath}
            commits={commitGroup.commits}
            shouldClipTimeline={shouldClipTimeline && index === 0}
            currentBlobPath={currentBlobPath}
            repo={repository}
            softNavToCommit={softNavToCommit}
          />
        )
      })}

      {trailingContent}
    </DeferredCommitDataProvider>
  )
}

try{ Commits.displayName ||= 'Commits' } catch {}